export interface TenantSaveState {
    securityDirty: boolean;
    detailReady: boolean;
    securityInvalid: boolean;
    autoregisterHasUnknownRole: boolean;
}

/**
 * Decide si el Guardar del modal de organización queda bloqueado. El detalle solo se exige cuando
 * cambió Seguridad: sin él no hay política real contra la cual guardar.
 */
export function tenantSaveBlocked(state: TenantSaveState): boolean {
    const securityBlocked = state.securityDirty && (!state.detailReady || state.securityInvalid);
    return securityBlocked || state.autoregisterHasUnknownRole;
}
